<template>
  <div class="coupon">
    <div class="page-header">
      <div class="disFlex fc frd">
        <div
          class="head-item disFlex vertical fvc"
          :class="{'active-item':currentType===1}"
          @click="changeType(1)"
        >
          <div>未使用</div>
          <div class="line" :class="{'active-line':currentType===1}"></div>
        </div>
        <div
          class="head-item disFlex vertical fvc"
          :class="{'active-item':currentType===2}"
          @click="changeType(2)"
        >
          <div>已使用</div>
          <div class="line" :class="{'active-line':currentType===2}"></div>
        </div>
      </div>
    </div>
    <div class="page-body" v-show="currentType==1">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
        <coupon-item
          v-for="item in unUsedList"
          :key="item.id"
          :item="item"
          :tradeNo="tradeNo"
          :buy="true"
        ></coupon-item>
      </van-list>
    </div>
    <div v-show="currentType==2">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
        <coupon-item
          v-for="item in usedList"
          :key="item.id"
          :item="item"
          :tradeNo="tradeNo"
          :buy="true"
        ></coupon-item>
      </van-list>
    </div>
  </div>
</template>

<script>
import CouponItem from "./../../components/coupon-item";
export default {
  components: {
    CouponItem,
  },
  data() {
    return {
      currentType: 1,
      usedList: [],
      unUsedList: [],
      finished: true,
      loading: false,
      tradeNo: 0,
    };
  },
  created() {
    this.getMyCoupon();
  },
  methods: {
    getMyCoupon() {
      this.$http.post("/v1/seckill/my_coupon").then((res) => {
        if (res.code === 0) {
          this.tradeNo = res.data.tradeNo;
          res.data.list.forEach((i) => {
            if (i.used) {
              this.usedList.push(i);
            } else {
              this.unUsedList.push(i);
            }
          });
        }
      });
    },
    changeType(e) {
      this.currentType = e;
    },
  },
};
</script>

<style lang="less" scoped>
.coupon {
  background: #fff;
  min-height: 100vh;
  .page-header {
    padding: 20px 0 0;
    border-bottom: 1px solid #f5f6f7;
    .head-item {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #696969;

      .line {
        width: 20px;
        height: 2px;
        background: transparent;
        margin-top: 13px;
      }
      .active-line {
        background: rgba(0, 48, 120, 1) !important;
      }
    }
    .active-item {
      color: rgba(0, 48, 120, 1) !important;
    }
  }
  .page-body {
  }
}
</style>